
import { Movie } from "@/types/movie";
import { ViewContext } from "@/components/movie/buttons/types";
import { useMovieContext } from "@/context";
import { useCommitToggle } from "@/hooks/movie/useCommitToggle";
import { LIST_NAMES } from "@/hooks/search/types/listConstants";

/**
 * Hook to get the appropriate context and handlers for action buttons
 * FIXED: Unseen Gems movies always use undo system for consistent behavior
 */
export const useActionButtonContext = (
  movie: Movie, 
  context: ViewContext, 
  currentTab?: string
) => {
  const { toggleFavorite, togglePlanToWatch, getVisualState, allMovies, addMovie, updateMovieState } = useMovieContext();
  
  // Get tmdbId early and ensure it's valid
  const tmdbId = movie.tmdbId || 0;
  const isValidMovie = tmdbId > 0;
  
  // Always call getVisualState but handle invalid movies gracefully
  const favoriteVisualState = isValidMovie 
    ? getVisualState(tmdbId, 'favorite') 
    : { currentValue: movie.favorite || false, isPending: false, isOptimistic: false };
    
  const planToWatchVisualState = isValidMovie 
    ? getVisualState(tmdbId, 'planToWatch') 
    : { currentValue: movie.planToWatch || false, isPending: false, isOptimistic: false };

  // FIXED: Determine if immediate action should be used
  // Only search results and dialog contexts use immediate actions
  // Unseen Gems always uses undo system for consistency
  const isImmediate = (context === "search" || 
                      context === "dialog" || 
                      context === "detail");

  // Use commit toggle hooks unconditionally
  const { commitToggleFavorite, commitTogglePlanToWatch } = useCommitToggle(
    allMovies, 
    addMovie, 
    updateMovieState, 
    getVisualState
  );

  return {
    tmdbId,
    isValidMovie,
    favoriteVisualState,
    planToWatchVisualState,
    isImmediate,
    toggleFavorite,
    togglePlanToWatch,
    commitToggleFavorite,
    commitTogglePlanToWatch
  };
};
